import {
    apiRequest,
    riwayatpenugasanCreate,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/riwayatpenugasanService"

class CreateRepository {

    fetchRegionCountry = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", riwayatpenugasanCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository